import * as React from "react";
const SvgFiRrHandHoldingSkull = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-holding-skull_svg__a)">
      <path
        fill="#062147"
        d="M5 7h1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7h1a1 1 0 0 0 1-1V4A4.005 4.005 0 0 0 7.601.02C5.523.22 4 2.09 4 4.176V6C4 6.551 4.448 7 5 7m5-4a1 1 0 1 1 0 2.001 1 1 0 0 1 0-2M6 3a1 1 0 1 1 0 2.001 1 1 0 0 1 0-2m17.018 5.785a2.97 2.97 0 0 0-2.169-.782 2.98 2.98 0 0 0-2.085.981l-3.217 3.534A3.15 3.15 0 0 0 12.858 11H4c-2.206 0-4 1.794-4 4v5c0 2.206 1.794 4 4 4h4.965c2.85 0 5.57-1.22 7.467-3.348l6.804-7.637a3.02 3.02 0 0 0-.218-4.229m-1.275 2.9-6.805 7.637A8 8 0 0 1 8.965 22H4c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2h8.857c.63 0 1.143.512 1.143 1.142a1.15 1.15 0 0 1-.98 1.131l-5.161.737a1 1 0 1 0 .283 1.98l5.161-.738a3.16 3.16 0 0 0 2.514-2.058l4.427-4.865c.181-.2.43-.316.699-.329.271-.005.528.082.728.262.407.372.44 1.01.072 1.421z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-holding-skull_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandHoldingSkull;
